import clsx from 'clsx'
import first from 'lodash/first'
import React, { FC } from 'react'

import openInNewTab from '@Assets/SVG/OpenInNewTab'
import { SVGIcon } from '@Components/Icons'
import { Link } from '@Components/Link'
import { isProductSpecificationReferenceExternalLink, isProductSpecificationReferencePage } from '@Components/Product/Specifications/types'
import { PageType, ProductSpecificationItemReference } from '@Generated/graphql'
import { useCMSModalOpen } from '@Globals/CMS/Modal/Hook'
import { pageTypeToDestinationPageType } from '@Globals/Page/Mappers'

import styles from './Reference.module.scss'

export interface SpecificationsItemReferenceProps {
  specification: ProductSpecificationItemReference
}

export const supportedModalPageTypes = new Map<string, PageType>([
  ['manuals', PageType.Manual],
  ['modals', PageType.Modal],
])

export const SpecificationsItemReference: FC<SpecificationsItemReferenceProps> = ({ specification }) => {
  const openModal = useCMSModalOpen()
  const specificationRef = first(specification?.references)

  if (isProductSpecificationReferenceExternalLink(specificationRef)) {
    return (
      <a className={clsx(styles.link, styles.externalLink)} href={specificationRef.url || '/'} rel="noreferrer" target="_blank">
        <span>{specification.text}</span>
        <SVGIcon icon={openInNewTab} />
      </a>
    )
  }

  if (isProductSpecificationReferencePage(specificationRef)) {
    const modalPageType = supportedModalPageTypes.get(specificationRef.type)
    const modalID = specificationRef.id

    if (modalPageType && modalID) {
      return (
        <button className={clsx(styles.link, styles.modalLink)} onClick={() => openModal(modalPageType, modalID)} type="button">
          {specification.text}
        </button>
      )
    }

    if (specificationRef.type && specificationRef.id && specificationRef.url) {
      return (
        <Link
          analytics={{
            dest_page_type: pageTypeToDestinationPageType(specificationRef.type),
            dest_page_type_id: specificationRef.id,
            source_id: 'specifications',
          }}
          className={clsx(styles.link)}
          href={specificationRef.url}
        >
          {specification.text || specificationRef.title}
        </Link>
      )
    }
  }

  return null
}
